// extracted by mini-css-extract-plugin
export default {"TypesMenu":"status_TypesMenu__jqiiR","InputWrapper":"status_InputWrapper__z2duH","ChooseType":"status_ChooseType__T3NTO"};